<template>
    <dialogmodal>
        <template v-slot:title>
            {{ this.$t('Payment') }}
        </template>
        <template v-slot:body>

            <!-- Дати та суми -->
            <div class="row g-3 mb-3">
                <!-- Дата до -->
                <div class="col-4">
                    <div class="text-center p-2 border rounded">
                        <p class="fs-13 text-muted mb-1">До перерахунку</p>
                        <p class="fs-16 fw-medium mb-0">{{ this.shortapplic.data.datepayments_before_recalc }}</p>
                    </div>
                </div>
                <!-- Днів -->
                <div class="col-4">
                    <div class="text-center p-2 border rounded bg-light">
                        <p class="fs-13 text-muted mb-1">Днів</p>
                        <p class="fs-16 fw-medium mb-0">{{ this.shortapplic.days > 0 ? '+' : '' }}{{ this.shortapplic.days }}</p>
                    </div>
                </div>
                <!-- Дата після -->
                <div class="col-4">
                    <div class="text-center p-2 border rounded">
                        <p class="fs-13 text-muted mb-1">Після перерахунку</p>
                        <p class="fs-16 fw-medium mb-0">{{ recalculatedDate }}</p>
                    </div>
                </div>
                <!-- Сума до -->
                <div class="col-4">
                    <div class="text-center p-2 border rounded">
                        <p class="fs-13 text-muted mb-1">Сума до</p>
                        <p class="fs-16 fw-medium mb-0">{{ this.shortapplic.data.lastsum || '—' }}</p>
                    </div>
                </div>
                <!-- Різниця -->
                <div class="col-4">
                    <div class="text-center p-2 border rounded" :class="summDiff > 0 ? 'bg-soft-success' : summDiff < 0 ? 'bg-soft-danger' : 'bg-light'">
                        <p class="fs-13 text-muted mb-1">Різниця</p>
                        <p class="fs-16 fw-medium mb-0" :class="summDiff > 0 ? 'text-success' : summDiff < 0 ? 'text-danger' : ''">
                            {{ summDiff > 0 ? '+' : '' }}{{ summDiff || '—' }}
                        </p>
                    </div>
                </div>
                <!-- Сума після -->
                <div class="col-4">
                    <div class="text-center p-2 border rounded">
                        <p class="fs-13 text-muted mb-1">Сума після</p>
                        <p class="fs-16 fw-medium mb-0">{{ this.shortapplic.data.summ || '—' }}</p>
                    </div>
                </div>
            </div>

            <table class="table">
                <thead>
                    <tr>
                    <th scope="col">{{this.$t('Name')}}</th>
                    <th scope="col">{{this.$t('Quantity')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="items, key  in this.data" :key="key">
                        <th scope="row">{{ this.mutateKey(key) }}</th>
                        <td>{{ items }}</td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-slot:footer-bottom></template>
    </dialogmodal>
</template>

<script>
import dialogmodal from '@/components/modal/modalsave.vue'

export default {
    props: ['shortapplic'],
    components: {
        dialogmodal
    },
    data() {
        return {
            data: {}
        }
    },
    mounted(){
        console.log('obj', this.shortapplic)

        Object.keys(this.shortapplic.data).forEach((element) => {
            if(
                element !== "paid_apps" &&
                element !== "summ" &&
                element !== "lastsum"
            ) {
                this.data[element] = this.shortapplic.data[element]
            }
        });
    },
    methods: {
        mutateKey(key) {
            let name = ""

            switch(key) {
                case "count_products":
                    name = this.$t('Number_of_goods')
                    break;
                case "count_techcards":
                    name = this.$t('Number_of_technical_cards')
                    break;
                case "count_terminals":
                    name = this.$t('NumberofTerminals')
                    break;
                case "count_tradepoints":
                    name = this.$t('numberTT')
                    break;
                case "tariffed_terminals_count":
                    name = this.$t('NumberofTerminals') + ` (${this.$t('Charged')})`
                    break;
                case "tariffed_tradepoints_count":
                    name = this.$t('numberTT') + ` (${this.$t('Charged')})`
                    break;
                case "datepayments_before_recalc":
                    name = this.$t('datepayments_before_recalc')
                    break;
                case "count_offlineprro":
                    name = this.$t('count_offlineprro')
                    break;
                case "count_servsync":
                    name = this.$t('count_servsync')
                    break;
            }
            return name
        }
    },
    computed: {
        recalculatedDate() {
            if (!this.shortapplic.data.datepayments_before_recalc || isNaN(this.shortapplic.days)) {
                return '—';
            }

            let initialDate = new Date(this.shortapplic.data.datepayments_before_recalc);
            initialDate.setDate(initialDate.getDate() + this.shortapplic.days);

            return initialDate.toISOString().split('T')[0]; // Формат YYYY-MM-DD
        },
        summDiff() {
            const summ = Number(this.shortapplic.data.summ) || 0;
            const lastsum = Number(this.shortapplic.data.lastsum) || 0;
            if (!summ && !lastsum) return null;
            return (summ - lastsum).toFixed(2);
        }
    },
};
</script>